<template>
  <div>
    <v-data-table
      :headers="headers" :items="transferData"
      :loading="loading"
      :pagination.sync="filter"
      :total-items="pagination.total"
      :rows-per-page-items="[pagination.perPage]"
      :no-data-text="$t('transfertable.noDataText')"
      :no-results-text="$t('transfertable.noResultsText')"
      :rows-per-page-text="$t('transfertable.rowsPerPageText')"
      :custom-sort="a => a"
      hide-actions>
      <template slot="items" scope="props">
        <td><date-formatter :value="props.item.date"></date-formatter></td>
        <td>{{ $t(`transfertable.status.${props.item.status}`) }}</td>
        <td class="text-xs-right"><price :value="props.item.amount"></price></td>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-3 pb-3">
      <v-pagination
        :disabled="loading"
        :value="filter.page"
        @input="value => changePage(value)"
        :length="Math.ceil(pagination.total / pagination.perPage)">
      </v-pagination>
    </div>
  </div>
</template>

<script>
  import pagination from '@/mixins/pagination'
  import { Price, Date as DateFormatter } from '@/components/formatters'
  export default {
    components: {
      DateFormatter,
      Price
    },
    mixins: [
      pagination('skiliko/transfers')
    ],
    data () {
      return {
        filter: {
          page: this.page
        }
      }
    },
    computed: {
      transferData () {
        return this.transfers
          .map(e => ({
            date: new Date((e.execution_date ? e.execution_date : e.creation_date) * 1000),
            status: e.status || 'CREATED',
            amount: e.debited_funds ? e.debited_funds.Amount : 0
          }))
      },
      headers () {
        return [
          { text: this.$t('transfertable.header.date'), left: true, sortable: false },
          { text: this.$t('transfertable.header.status'), left: true, sortable: false },
          { text: this.$t('transfertable.header.amount'), left: false, sortable: false }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TransferTable.vue